import { createAsyncThunk } from '@reduxjs/toolkit';

import { type TJsonQuery } from '@/packages/JsonQuery';

import { prepareDistrictsTree } from '@/microfrontends/filters/shared/mappers/prepareDistrictsTree';
import { fetchDistrictsTree } from '@/microfrontends/filters/shared/services/fetchDistrictsTree';
import { type TThunkApi } from '@/microfrontends/filters/shared/store';
import { type IDistrictTree } from '@/microfrontends/filters/shared/types/districtTree';
import { type IGeoTagsMap } from '@/microfrontends/filters/shared/types/geoTags';
import { tempNormalizeLocation } from '@/microfrontends/filters/shared/utils/tempNormalizeLocation';

interface IOpenResult {
  districts: IDistrictTree[];
  jsonQuery: TJsonQuery;
  geoTags: IGeoTagsMap;
}

export const open = createAsyncThunk<IOpenResult, undefined, TThunkApi>(
  'districtsPopup/open',
  async (_, thunkApi) => {
    const { extra, getState } = thunkApi;

    const state = getState();

    const subdomain = extra.custom.subdomain;
    const jsonQuery = state.jsonQuery.current;
    const geoTags = state.geoTags.data;
    const currentLocation = state.location.data;
    const currentLocationNormalized = tempNormalizeLocation(currentLocation);

    const districtsTreeResult = await fetchDistrictsTree(
      extra,
      { locationId: currentLocationNormalized[0].id },
      { subdomain },
    );
    const districts: IDistrictTree[] = districtsTreeResult.map(prepareDistrictsTree).unwrapOr([]);

    return {
      districts,
      jsonQuery,
      geoTags,
    };
  },
  {
    condition: (_, thunkApi) => {
      const state = thunkApi.getState();

      return state.districtsPopup.status !== 'loading';
    },
  },
);
